import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    brandName: Yup.string()
      .required("common:validator.required")
      .max(50, "common:validator.max50Chars"),
  });
};
